import marketplaceLinks from './marketplaceLinks';

export default marketplaceLinks;
